import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { OrderActionTypes, OrderActions } from '../actions/order.actions';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import {PurchaseService} from '../../../services/purchse.service';
import {updateInfoType} from '../../../shareModel';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {OrderReceiptChkParams} from '../purchase.model';

@Injectable()
export class OrderEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private purchaseService = inject(PurchaseService);

  constructor() {}

  CreateOrders$ = createEffect(() => this.actions$.pipe(
    ofType(OrderActionTypes.CreateOrder),
    map((action: featureActions.CreateOrder) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const reloadPlanSetting = payload.otp === undefined; // mobile-purchase 不須reload Plan Setting
      // NgRx 9 不可變性: 創建新對象副本
      const params = { ...payload, otp: payload.otp ? payload.otp : user.otp };
      return this.purchaseService.NewOrder(params).pipe(
        map((res: any) => {
          const result = { ...res, type: updateInfoType.CreateOrder };
          if (result.result && result.msg.body > 0) {
            if (reloadPlanSetting) {
              this.store$.dispatch(new featureActions.GetPlanSettings());
            }
            this.store$.dispatch(new featureActions.UpdateInfoSuccessAction(result));
            // return [new featureActions.GetPlanSettings(), new featureActions.LoadOrder() ,
            // new featureActions.UpdateInfoSuccessAction(result)];
            return new featureActions.LoadOrder();
          }
          throw new Error('update fail');
        }),
        // switchMap((infoId: number) => {
        //   const params: OrderReceiptChkParams = {
        //     otp: payload.otp,
        //     InfoId: infoId,
        //     Receipt: payload.TxId,
        //     CURCode: 'USD', // For now, only USD.
        //     CURSymbol: '$', // For now, only $.
        //     Amount: payload.Amount,
        //     ReceiptChk: 1 // For now, always 1.
        //   };
        //   return this.purchaseService.OrderCheckReceipt(params).pipe(
        //     map((res: any) => {
        //       return new featureActions.LoadOrder();
        //     })
        //   );
        // }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.CreateOrder
          };
          return of(new featureActions.UpdateInfoFailAction(res));
        })
      );
    })
  ));



}
